<template>
  <l-table
    ref="LTable"
    :module-name="MODULE_NAME"
    :table-columns="tableColumns"
  >
    <template #create-button>
      <b-button
        v-if="$can('manage', RESOURCE)"
        v-b-toggle.sidebar-create-confirmed-scientific-topic-protocol
        variant="primary"
        @click="create"
      >
        {{ $t('Create') }}
      </b-button>
    </template>
    <template #create-body>
      <create @refetchData="refetchData" />
    </template>

    <template #cell(file)="{ data }">
      <b-link
        v-if="data.value"
        :href="data.value"
        target="_blank"
      >
        {{ $t('Download') }}
      </b-link>
    </template>

    <template #cell(actions)="{ data }">
      <div class="text-nowrap">
        <b-button
          v-if="$can('manage', RESOURCE)"
          variant="outline-danger"
          size="sm"
          class="p-25 mx-1"
          @click="remove(data.item)"
        >
          <feather-icon
            icon="TrashIcon"
            size="16"
          />
        </b-button>
      </div>
    </template>
  </l-table>
</template>

<script>
import {
  BButton, BLink, VBToggle,
} from 'bootstrap-vue'
import { onUnmounted } from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import store from '@/store'
import config from './config'
import confirmedScientificTopicProtocolModule from '@/store/confirmed-scientific-topic-protocol/index'
import Create from './Create.vue'
import LTable from '@/views/components/LTable.vue'

const RESOURCE = 'ScientificTopicProtocol'

export default {
  directives: {
    Ripple,
    'b-toggle': VBToggle,
  },
  components: {
    LTable,
    BButton,
    BLink,
    Create,
  },
  created() {
    this.$store.commit(`${this.MODULE_NAME}/FRESH`)
  },
  methods: {
    remove(data) {
      this.$removeSwal(this, data, `${this.MODULE_NAME}/del`, this.refetchData)
    },
    create() {
      this.$store.commit(`${this.MODULE_NAME}/FRESH`)
    },
    refetchData() {
      this.$refs.LTable.refetchData()
    },
  },
  setup() {
    const MODULE_NAME = 'confirmedScientificTopicProtocol'

    if (!store.hasModule(MODULE_NAME)) store.registerModule(MODULE_NAME, confirmedScientificTopicProtocolModule)

    onUnmounted(() => {
      if (store.hasModule(MODULE_NAME)) store.unregisterModule(MODULE_NAME)
    })

    return {
      MODULE_NAME,
      RESOURCE,
      ...config(),
    }
  },
}
</script>
